import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { microservices } from '@api/microservices.type';
import { environment } from '@environments/environment';
import { RewardsResponse, RewardsWalletTransactionResponse, WalletTotalResponse } from '@shared/models/interfaces/rewards-wallet.interface';
import { Observable } from 'rxjs';
import { RewardsWalletRepository } from './rewards-wallet.repository';

@Injectable({
    providedIn: 'root',
})
export class RewardsWalletApiService implements RewardsWalletRepository {
    readonly http = inject(HttpClient);

    getRewardsTotal(): Observable<WalletTotalResponse> {
        return this.http.get<WalletTotalResponse>(`${environment.url}${microservices.rewards_wallet}/user-wallet/promotions/active/totals`);
    }

    getTransactions(page = 1, pageSize = 1): Observable<RewardsWalletTransactionResponse> {
        const params = new HttpParams().set('page', page).set('pageSize', pageSize);
        const options = {
            params,
        };
        return this.http.get<RewardsWalletTransactionResponse>(
            `${environment.url}${microservices.rewards_wallet}/user-wallet/promotions/transactions`,
            options
        );
    }

    getRewardsActive(): Observable<RewardsResponse> {
        return this.http.get<RewardsResponse>(`${environment.url}${microservices.rewards_wallet}/user-rewards/promotions/active`);
    }
}
